import React from "react";
import { useClientTable, Text, DataTable } from "@pushpress/shared-components";
import { DataTableProps } from "@pushpress/shared-components/build/components/data/DataTable";
import StaffCard from "../../../components/cards/StaffCard/StaffCard";
import { StaffRowFragment } from "./AppointmentPayRateList-generated.hooks";

interface PayRatesTableProps<K extends string>
  extends Pick<
    DataTableProps<StaffRowFragment, K>,
    "data" | "renderRowMenu" | "loading"
  > {
  data: StaffRowFragment[];
}

const getRowId = (row: StaffRowFragment) => {
  return row.userUuid + "";
};

function PayRatesTable<K extends string>({
  data: dataProp,
  renderRowMenu,
  ...other
}: PayRatesTableProps<K>) {
  const columns = [
    {
      key: "staff",
      header: "Staff",
      isSortable: true,
      width: "25%",
      widthMobile: "100%",
      sort: (a: StaffRowFragment, b: StaffRowFragment) =>
        a?.firstName.localeCompare(b?.firstName),
      cell: (row: StaffRowFragment) => {
        if (!row?.firstName && !row?.lastName) {
          return "- -";
        }
        return <StaffCard staff={row} />;
      },
    },
    {
      header: "Rates",
      key: "rates",
      hideOnMobile: true,
      cell: ({ payRates }: StaffRowFragment) => {
        const formattedPayRates = payRates
          .map(({ appointmentType: v }) => `${v.name} (${v.duration / 60}min)`)
          .join(", ");
        return <Text variant="body-lg">{formattedPayRates}</Text>;
      },
    },
  ];

  const { data, sort, handleSort } = useClientTable({
    data: dataProp || [],
    columns,
    defaultSort: { key: "staff", order: "asc" },
  });

  return (
    <DataTable
      {...other}
      columns={columns}
      data={data}
      sort={sort}
      renderRowMenu={renderRowMenu}
      getRowId={getRowId}
      onSort={handleSort}
    />
  );
}

export default PayRatesTable;
